import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { LockComponent } from './lock/lock.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ProfileComponent } from './profile/profile.component';
import { AdminRightComponent } from './settings/admin-right/admin-right.component';
import { AdministratorComponent } from './settings/administrator/administrator.component';
import { CountriesComponent } from './settings/countries/countries.component';
import { CurrenciesComponent } from './settings/currencies/currencies.component';
import { AreasComponent } from './settings/areas/areas.component';
import { DocumentTypeComponent } from './settings/document/document.component';
import { DealslipComponent } from './dealslip/dealslip.component';
import { CrossExchangeRateComponent } from './cross-exchange-rate/cross-exchange-rate.component';
import { UserManageComponent } from './users/manage/manage.component';
import { UserKycComponent } from './users/kyc/kyc.component';
import { DetailsComponent } from './users/details/details.component';
import { IdentityDocumentComponent } from './settings/identity-document/identity-document.component';
import { HrPeopleComponent } from './hr/people/people.component';
import { HrStaffDetailsComponent } from './hr/staff-details/staff-details.component';
import { TreasuryComponent } from './treasury/treasury.component';
import { FinancePlComponent } from './finance-pl/finance-pl.component';
import { PermissionGuard } from './_services/permission.guard';

const routes: Routes = [
  { path: "", component: DashboardComponent, canActivate: [PermissionGuard] },
  { path: "login/error/:error", component: LoginComponent },
  { path: "login/done/:done", component: LoginComponent },
  { path: "login", component: LoginComponent },
  { path: "logout/:parameter", component: LogoutComponent },
  { path: "logout", component: LogoutComponent },
  { path: "lock", component: LockComponent },
  { path: "password", component: ForgotPasswordComponent },

  { path: "settings/administrator/right", component: AdminRightComponent, canActivate: [PermissionGuard] },
  { path: "settings/administrator/:view", component: AdministratorComponent, canActivate: [PermissionGuard] },
  { path: "settings/administrator", component: AdministratorComponent, canActivate: [PermissionGuard] },
  { path: "settings/countries/areas/:id", component: AreasComponent, canActivate: [PermissionGuard] },
  { path: "settings/countries/:view", component: CountriesComponent, canActivate: [PermissionGuard] },
  { path: "settings/countries", component: CountriesComponent, canActivate: [PermissionGuard] },
  { path: "settings/currencies/:view", component: CurrenciesComponent, canActivate: [PermissionGuard] },
  { path: "settings/currencies", component: CurrenciesComponent, canActivate: [PermissionGuard] },
  { path: "settings/document/:view", component: DocumentTypeComponent, canActivate: [PermissionGuard] },
  { path: "settings/document", component: DocumentTypeComponent, canActivate: [PermissionGuard] },
  { path: "settings/identity", component: IdentityDocumentComponent, canActivate: [PermissionGuard] },

  { path: "dealslip/cross-exchange-rate", component: CrossExchangeRateComponent, canActivate: [PermissionGuard] },
  { path: "dealslip/:view", component: DealslipComponent, canActivate: [PermissionGuard] },
  { path: "dealslip", component: DealslipComponent, canActivate: [PermissionGuard] },

  { path: "hr", redirectTo: "hr/payroll-tax", pathMatch: "full" },
  { path: "hr/staff/:id", component: HrStaffDetailsComponent, canActivate: [PermissionGuard] },
  { path: "hr/:section", component: HrPeopleComponent, canActivate: [PermissionGuard] },
  { path: "treasury", redirectTo: "treasury/currency-swap-dashboard", pathMatch: "full" },
  { path: "treasury/:section", component: TreasuryComponent, canActivate: [PermissionGuard] },
  { path: "finance-pl", redirectTo: "finance-pl/pl-statement", pathMatch: "full" },
  { path: "finance-pl/:section", component: FinancePlComponent, canActivate: [PermissionGuard] },

  { path: "users/manage/:view", component: UserManageComponent, canActivate: [PermissionGuard] },
  { path: "users/manage", component: UserManageComponent, canActivate: [PermissionGuard] },
  { path: "users/kyc/:view", component: UserKycComponent, canActivate: [PermissionGuard] },
  { path: "users/kyc", component: UserKycComponent, canActivate: [PermissionGuard] },
  { path: "users/details/:id", component: DetailsComponent, canActivate: [PermissionGuard] },
  { path: "users/:view", component: UserManageComponent, canActivate: [PermissionGuard] },
  { path: "users", component: UserManageComponent, canActivate: [PermissionGuard] },


  { path: "profile/:id", component: ProfileComponent, canActivate: [PermissionGuard] },
  { path: "profile", component: ProfileComponent, canActivate: [PermissionGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
